import React, { useState, useEffect } from "react";
import Header from "../../components/header/index.js";
import LeftMenu from "../../components/left-menu/index.js";
import { useSelector } from 'react-redux';
import {useNavigate} from "react-router-dom";
import Grid from '@mui/material/Grid';
import {readEmpty} from "../SalesMeeting/apiEmpty.js";
import "./style.css";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import { Select, MenuItem } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import axios from "axios";
import Button from '@mui/material/Button';
import { Typography, Dialog, LinearProgress, DialogContent, Box } from "@mui/material";
import TextField from '@mui/material/TextField';
import Autocomplete from "@mui/material/Autocomplete";
import CheckIcon from "@mui/icons-material/Check";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import {Switch} from "@mui/material";
export default function LegalProcess() {
    
    // Add a state variable to hold the selected file
    const [file, setFile] = useState(null);
    const [selectedSales, setSelectedSales] = useState([]);
    const [selectedLokasi, setSelectedLokasi] = useState([]);

    // Handle file selection
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };
    const [imageUrl, setImageUrl] = useState(null); // State to hold the URL of the image
    const navigate = useNavigate();
    const getURL = () => {
        if (!file) {
            alert("Please select a file to upload.");
            return;
        }
    
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/getUploadURL`)
            .then(response => {
                const uploadUrl = response.data.url;
                const key = response.data.key; // assuming this is returned by your API
    
                fetch(uploadUrl, {
                    method: "PUT",
                    headers: {
                        "Content-Type": file.type // Use the type of the selected file
                    },
                    body: file
                })
                .then(response => {
                    if (!response.ok) { throw response }
    
                    // Fetch the file from your backend using the `key`
                    axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${encodeURIComponent(key)}`, {
                        responseType: 'blob' // Tell axios to get the response as a blob
                    })
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'file.pdf'); // or any other extension
                        document.body.appendChild(link);
                        link.click();
                        const file = new Blob([response.data], {type: 'application/pdf'});
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
                    })
                    .catch(error => {
                        console.error("Error during file retrieval:", error);
                    });
                })
                .catch(error => {
                    console.error("Error during file upload:", error);
                });
            });
    }
    
    
    
    const nowstate = useSelector(state => state);
    const [judul,setJudul] = useState();
    const [posts, setPosts] = useState([])
    const [fileURL, setFileURL] = useState("");

    const [lokasi, setLokasi]= useState(["Lokasi Sendiri","VO Kokas", "VO G.Serpong", "VO Duta Merlin", "VO Bekasi", "PO Kokas", "PO G.Serpong", "PO Duta Merlin", "PO Bekasi"])
    const [checkedState, setCheckedState] = useState({
        'Pendirian PT': false,
        'Pendirian CV': false,
        'PT Perorangan': false,
        'PKP': false,
        'SIUJK': false,
        'IUPJPT': false,
        'Izin Khusus': false,
        'Jual Beli Saham': false,
        'Ganti Pengurus': false,
        'Mutasi Alamat': false,
        'Perubahan KBLI': false,
        'Update OSS RBA': false,
        'Pendaftaran Merek': false,
        // Add more checkboxes as needed
    });
    const [nomorKlien,setNomorKlien]=useState()

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
        const day = String(date.getDate()).padStart(2, '0');
        const month = monthNames[date.getMonth()]; // get month name
        const year = date.getFullYear().toString();
        return `${day} ${month} ${year}`;
    };
    const formatLokasi = (lokasi) => {
        const lokasiMappings = {
            'Office Tower Eightyeight@Kasablanka Unit 9A': 'Kokas',
            'Ruko Emerald Summarecon Bekasi UC9': 'Bekasi',
            'Ruko Graha Boulevard Summarecon Serpong Blok GBVB 10': 'Serpong',
            'Komplek Perkantoran Duta Merlin Blok F1': 'Duta Merlin'
        };
    
        return lokasiMappings[lokasi] || '';
    };

    const handleChange = (event) => {
        setCheckedState({ ...checkedState, [event.target.name]: event.target.checked });
    };
    const [bDate,setbDate] = useState(Date())
    const [endDate,setendDate] = useState(Date(Date.now() + 1 * 24 * 60 * 60 * 1000))
    const [startDate, setStartDate] = useState(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)) // 7 days before the current date
    const [state, setState] = useState({
        gilad: false,
        jason: false,
        antoine: true,
      });

      const [status,setStatus] = useState("PMDN")
      const handleDateChange = (event) => {
        setbDate(event);
    }
      const switchChange = (event) => {
        setSelectedSales("")
        setState({
          ...state,
          [event.target.name]: event.target.checked,
        });
        if(status === "PMDN"){
          setStatus("PMA")
        }else{
          setStatus("PMDN")
        }
      }
      const previewInquiry = async (post) => {
    // Convert the post object to a string to store in local storage
  const postString = JSON.stringify(post);
  // Use a unique key for this particular piece of data
  localStorage.setItem('currPreview', postString);
  // Open a new tab. The URL should be the route where you handle the preview.
  // Assuming you have a route like '/preview' set up for this
  window.open('/specificcase', '_blank');
    }
    const [isEnd,setIsEnd] = useState("loading..")

      const [loadVisibility, setLoadVisibility] = useState(false)
      const saveLegal = () => {
        setLoadVisibility(true)       
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/saveLegal1`, {
            
          })
          .then(response => {
                    
            
            }).catch(err => {
                console.error(err);
            }); 
        }

        const [filterThis, setfilterThis] = useState("Extend")
        const commonStyles = {
            border: 1,
          };
        const [sales, setSales] = useState("Semua")
        const [skip,setSkip] = useState(0)
        const setSalesNow = async (event) => {
            setSales(event.target.value)
            try{
                setPosts([])
                const data = await readEmpty(event.target.value, filterThis, startDate, endDate);
                console.log(data)
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                console.log(data)
    
                //success
                setPosts([...data])
            }catch(error){
                console.log(error.message);
            } 
        }
        const setStartDateNow = async (event) => {
            setStartDate(event)
            try{
                setPosts([])
                const data = await readEmpty(sales, filterThis, event, endDate);
                console.log(data)
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                console.log(data)
    
                //success
                setPosts([...data])
            }catch(error){
                console.log(error.message);
            } 
        }
        const setendDateNow = async (event) => {
            setendDate(event)
            try{
                setPosts([])
                const data = await readEmpty(sales, filterThis, startDate, event);
                console.log(data)
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                console.log(data)
    
                //success
                setPosts([...data])
            }catch(error){
                console.log(error.message);
            } 
        }
        const setfilterThisNow = async (event) => {
            setfilterThis(event.target.value)
            try{
                setPosts([])
                const data = await readEmpty(sales, event.target.value, startDate, endDate);
                console.log(data)
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                console.log(data)
    
                //success
                setPosts([...data])
            }catch(error){
                console.log(error.message);
            } 
        }
        const [currPreview,setCurrPreview] = useState("none")
        const donePost = (postId) => {
        };
        const handleTidakExtentPreview = () => {
            setTidakExtendPreview(true)
        }
    
        const handleCloseTidakExtendPreview = () => {
            setTidakExtendPreview(false)
        }
        const [tidakExtendPreview, setTidakExtendPreview] = useState(false)

        useEffect(() => {
            // Retrieve the post data from local storage
            const postString = localStorage.getItem('currPreview');
            if (postString) {
              const post = JSON.parse(postString);
              // Now you have your post object back
              // Set it to your state or whatever you need to do next
              setCurrPreview(post); // Assuming you have a useState hook to hold this
              console.log(post)
              // Optionally, clear the item from local storage if it's no longer needed
              localStorage.removeItem('currPreview');
              if ('kontrak_id' in post) {
              const id = post.kontrak_id
              const thisClient= post.data.KlienID
              axios.get(`${process.env.REACT_APP_BACKEND_URL}/KlienProfile`, {
                  params: {
                      thisClient: thisClient
                  }
              })
              .then(resp => {
                  setNomorKlien(resp.data.data[0].Phone[0]);
              })
              .catch(error => {
                  console.error('Error:', error);
                  if (error.response) {
                      console.error('Error data:', error.response.data);
                      console.error('Error status:', error.response.status);
                      console.error('Error headers:', error.response.headers);
                  } else if (error.request) {
                      console.error('Error request:', error.request);
                  } else {
                      console.error('Error message:', error.message);
                  }
              });
              
              axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakVOfromDB`,{
                  id
               }, {
                   responseType: "blob"
                 }).then(resp => {
                           console.log(resp)
                               const blob = new Blob([resp.data], { type: 'application/pdf' })
                           // saveAs(blob);
                           var fileURLNew = URL.createObjectURL(blob);
                           console.log(fileURLNew)
                           setFileURL(fileURLNew)
                       })
                       console.log("diatas")
                       setCurrPreview(post)
            }}else{}
          }, []);
        const newFetchPosts = async (event) => {
            setPosts([])
            setIsEnd("Loading...");
                try{
                    const { data, error } = await readEmpty(sales, filterThis, startDate, endDate);
                    if(error){
                        console.log(error.message);
                        return;
                    }
        
                    if(data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }
                    console.log(data)
    
                    
                    //success
                    setPosts([...posts, ...data])
                }catch(error){
                    console.log(error.message);
                } 
        }

        
        const fetchPosts = async () => {

    
            try{
                const data = await readEmpty(sales, filterThis, startDate, endDate);
                console.log(data)
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                console.log(data)
    
                //success
                setPosts([...data])
            }catch(error){
                console.log(error.message);
            } 
            
        }
        const [tanggal, setTanggal] = useState(new Date);
const [notes, setNotes] = useState('');
const [response, setResponse] = useState('');
const handleSave = () => {
    console.log(tanggal)
    const dateObj = new Date(tanggal);

    // Get the day, month, and year from the date object
    const day = dateObj.getDate().toString().padStart(2, '0'); // Pad with leading zero if necessary
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // Add 1 because months are zero-indexed, and pad with leading zero
    const year = dateObj.getFullYear();    
    const formattedDate = `${day}/${month}/${year}`;
    const newItem = {
      Date: formattedDate,
      Note: notes,
      Response: response,
    };
  
    // Assuming currPreview and setCurrPreview are your state and its setter
    setCurrPreview((prevPreview) => ({
      ...prevPreview,
      management: {
        ...prevPreview.management,
        fu: [newItem, ...prevPreview.management.fu], // Prepend new item
      },
    }));
    console.log(currPreview)
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/salesmeetinfuupdate`,{
        id: currPreview._id, newItem: newItem, currPreview:currPreview
    })
  
    // Optionally, clear the input fields after saving
    setNotes('');
    setResponse('');
  };
    return (
        <Grid container>
                <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Grid item  xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
                    <LeftMenu/>
                </Grid>
                <Grid xl={11.5} lg={11.3} md={10.4} sm={8.8} >
                <Grid className="boxshadowclass" position="fixed" width="98%" xs={12} zIndex="100" opacity="1">
                <Header judul="Specific Case" isi="Legal Baru"></Header>
                </Grid>
                <Grid sx={{ mt:15, pl:5}}></Grid>
                                 {/*........................................................Untuk legal Vieww/Dashboard yaaaaaaa .........................................................................................................................................*/}
                                 {currPreview.tipe !== "Private Office" && currPreview.tipe !== "Virtual Office" ? (
            // Content for cases other than Private Office or Virtual Office
            <Grid>
                <Grid container sx={{pl:5, pr:5}}>
                    <Typography>Nomor Telepon: {currPreview.Phone}</Typography>
                    {/* Additional content as required */}
                </Grid>
                <Grid container sx={{pl:5, pr:5}}>
                    <Typography>Sales: {currPreview.Sales}</Typography>
                    {/* Additional content as required */}
                </Grid>
                <Grid container sx={{pl:5, pr:5}}>
                    <Typography>PI: {currPreview.PIlink?? "No"}</Typography>
                    {/* Additional content as required */}
                </Grid>
                <Grid container sx={{pl:5, pr:5}}>
                    <Typography>Produk: {currPreview.ProdukInterest?? "Unknown"}</Typography>
                    {/* Additional content as required */}
                </Grid>
                <Grid container sx={{pl:5, pr:5}}>
                    <Typography>Nama: {currPreview.Nama?? "Unknown"}</Typography>
                    {/* Additional content as required */}
                </Grid>
                <Grid container sx={{pl:5, pr:5}}>
                    <Typography>Chatlink: {currPreview.chatLink}</Typography>
                    {/* Additional content as required */}
                </Grid>
            </Grid>
        ) : (
            // Existing content for Private Office or Virtual Office
            <>
            <Grid sx={{mb: 5}}>
                        <Typography align="center" variant="h5">
                            <b>
                                {currPreview.tipe === 'Virtual Office' ? 
                                    `Virtual Office ${currPreview.data.CompanyName} ${currPreview.notes}` :
                                    currPreview.tipe === 'Private Office' ? 
                                    `Private Office ${currPreview.data.CompanyName} ${currPreview.notes}` :
                                    'N/A' // Default case if neither condition is met
                                }
                            </b>
                        </Typography>

                    </Grid>
                    <Grid container sx={{pl:5, pr:5}}>
                        <Grid item xs={6}>
                            <iframe src={`${fileURL}#zoom=70`} width="100%" height="250" style={{zoom:"150%"}}/>
                        </Grid>
                        <Grid xs={1}></Grid>
                        <Grid item xs={5}>
                                <Grid item xs={12} sx={{mb:5}}>
                                    {currPreview.tipe === 'Virtual Office' ? 
                                        <div>
                                            <div><b>Expired :</b>{` ${formatDate(currPreview.data.TanggalBerakhir)}`}</div>
                                            <div><b>Lokasi :</b>{` ${formatLokasi(currPreview.data.LokasiKontrak)}`}</div>
                                            <div><b>Paket  :</b>{` ${currPreview.data.NamaPaket}`}</div>
                                        </div> :
                                        <div>
                                            <div><b>Lokasi :</b>{` ${formatLokasi(currPreview.data.LokasiKontrak)}`}</div>
                                            <div><b>Ruangan :</b>{` ${currPreview.data.selectedRooms.join(', ')}`}</div>
                                            <div><b>Periode :</b>{` ${formatDate(currPreview.data.isMatching[0].StartInterval)} - ${formatDate(currPreview.data.isMatching[0].EndInterval)}`}</div>
                                        </div>
                                    }
                                </Grid>
                            <Button 
                                variant="contained" 
                                color="success" 
                                onClick={() => {
                                    const phoneNumber = currPreview.Phone; // Use the phone number from currPreview
                                    const message = ''; // Replace with your message or leave it empty
                                    const encodedMessage = encodeURIComponent(message);
                                    const whatsappUrl = `https://wa.me/${nomorKlien}`;
                                    window.open(whatsappUrl, '_blank');
                                }}
                            >
                                <WhatsAppIcon />
                            </Button>
                            <Grid></Grid>
                            <Button 
                                    variant="contained" 
                                    color="error" sx={{mr:3}}
                                    onClick={() => {
                                        handleTidakExtentPreview();
                                        // invalidPost(currPreview._id);
                                        // handleClosePreview();
                                    }}
                                >
                                    Tidak Extend
                                </Button>
                                <Grid></Grid>
                            <Button 
                                    variant="contained" 
                                    sx={{mr:3}}
                                    onClick={() => {
                                        handleTidakExtentPreview();
                                        // invalidPost(currPreview._id);
                                        // handleClosePreview();
                                    }}
                                >
                                    Sudah Extend
                                </Button>
                        </Grid>

                    </Grid>
                {/* ... Rest of your existing content ... */}
            </>
        )}
        <Grid sx={{pl:5, pr:5, mt:5}}>
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <TableContainer sx={{ maxHeight: 300, minHeight: 300 }} className="min-h-screen h-screen overflow-scroll">
                            <Table stickyHeader aria-label="sticky table">
                                <TableBody>
                                {
  currPreview.management?.fu?.length > 0 ? (
    currPreview.management.fu.map((post, index) => (
      <TableRow hover key={index}> {/* Use the index as a key for lack of a better unique identifier */}
        <TableCell sx={{ ...commonStyles, borderColor: 'grey.100', }}>
          {post.Date}
        </TableCell>
        <TableCell sx={{ ...commonStyles, borderColor: 'grey.100', }}>
          {post.Note}
        </TableCell>
        <TableCell sx={{ ...commonStyles, borderColor: 'grey.100', }}>
          {post.Response}
        </TableCell>
        {/* Other TableCell components */}
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={5} style={{ textAlign: "center" }}>
        No Data
      </TableCell>
    </TableRow>
  )
}
                                    {isEnd && (
                                        <TableRow>
                                            <TableCell colSpan={5} style={{ textAlign: "center" }}>
                                                
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </Paper>
                    <Grid container sx={{mt:5}}>
                        <Grid xs={2}>Tanggal</Grid>
                        <Grid xs={5}>Notes</Grid>
                        <Grid xs={5}>Respon</Grid>
                    </Grid>
                    <Grid container>
                        <Grid xs={2}>
                        <LocalizationProvider color="#FFFFFF" dateAdapter={AdapterDateFns}>
                    <MobileDatePicker views={['day','month', 'year']} color="#FFFFFF" inputFormat="dd/MM/yyyy"
                        placeholder="Tanggal"
                        value={tanggal}
                        onChange={(event) => {
                            setTanggal(event);
                        }}
                        renderInput={(params) => <TextField fullWidth  {...params} InputProps={{endAdornment: (
                        <InputAdornment color="#FFFFFF" position="end">
                            <CalendarMonthIcon />
                        </InputAdornment>
                    ),
                    }}/>}

                        />
                        </LocalizationProvider>
                        </Grid>
                        <Grid xs={5}>
                            <TextField fullWidth value={notes} onChange={(e) => setNotes(e.target.value)} />
                        </Grid>
                        <Grid xs={5}>
                            <TextField fullWidth value={response} onChange={(e) => setResponse(e.target.value)} />
                        </Grid>
                    </Grid>
                    <Button variant="contained" sx={{mt:5}} onClick={handleSave}>Simpan</Button>
                    </Grid>
        
            </Grid>
        </Grid>
    );
}
